import { useState } from "react";

const useDrawer = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerHeading, setDrawerHeading] = useState("Heading");
  const [drawerContent, setDrawerContent] = useState("Content");
  const [drawerAnchor, setDrawerAnchor] = useState("right");

  const handleDrawer = (heading, content, anchor) => {
    setOpenDrawer((previousOpenDrawer) => !previousOpenDrawer);
    if (heading) {
      setDrawerHeading(heading);
    }
    if (content) {
      setDrawerContent(content);
    }
    if (anchor) {
      setDrawerAnchor(anchor);
    }
  };

  return {
    openDrawer,
    handleDrawer,
    drawerHeading,
    drawerContent,
    drawerAnchor,
  };
};

export default useDrawer;
